import store from '../../store/index';
import { trackPageView } from '../../tracking/adobe';
import tagRecordings from '../../tracking/hotjar/tagRecordings';

const trackPageViewLookup = {
  '/v/registrar':                   'reg1-view',
  '/v/pessoal':                     'reg2-view',
  '/v/financeiro':                  'reg3-view',
  '/loan_applications/loan_offers': 'reg4-view',
  '/loan-status':                   'loan-status-view',
};

export default async function afterEach(to) {
  try {
    trackPageView(trackPageViewLookup[to.path] || to.path);
    // Hotjar Tagging
    tagRecordings([to.name]);
    tagHotjarRecordingsByEvars();
  } catch {
    // proceed without nice-to-have tracking
  } finally {
    store.dispatch('setAwaitingNavigation', false);
    window.dispatchEvent(new Event('historyPush'));
  }
}
